"use client";

/**
 * The 404 page's "take me somewhere real" button, host-aware.
 *
 * On the data-room host every route but `/vault` and `/login` is rewritten
 * to a 404 by the host gate, so the default CTA ("Go to Library" →
 * `/first-look`) would be a dead link — and would also tell a client that
 * a Library exists. Client component so the 404 page itself stays static:
 * reading `headers()` in `not-found.tsx` would make every not-found render
 * dynamic.
 */

import Link from "next/link";

import { isVdrBrowser, VDR_HOME } from "@/lib/vault/portal";

export default function NotFoundHomeLink() {
  const vdr = isVdrBrowser();
  return (
    <Link
      href={vdr ? VDR_HOME : "/first-look"}
      className="inline-flex items-center gap-1.5 h-9 px-5 rounded-md text-[13px] font-body bg-accent-blue hover:bg-accent-hover text-white transition-colors shadow-sm"
      data-name="not-found-home-link"
    >
      {vdr ? "Back to your document room" : "Go to Library"}
    </Link>
  );
}
